import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "phone-header-container"
};
const _hoisted_2 = {
  class: "phone-container-w"
};
const _hoisted_3 = {
  class: "image-slot"
};
const _hoisted_4 = {
  class: "image-slot"
};
import { ref, watch } from 'vue';
import { CircleClose, Picture as IconPicture } from '@element-plus/icons-vue';
import PhoneMenu from './PhoneMenu'; // 组件-移动端-导航栏
import { useRouter, useRoute } from 'vue-router';
export default /*@__PURE__*/Object.assign({
  name: 'PhoneHeader'
}, {
  __name: 'index',
  props: {
    logo: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const props = __props;
    const isShowNav = ref(false); // 导航栏显隐开关
    // 事件函数-导航栏显隐切换
    const navChange = () => {
      isShowNav.value = !isShowNav.value;
    };
    let nowPath = route.path; // 记录当前路由
    watch(() => route.path, newPath => {
      // 当前路由进行了切换,关闭导航栏
      if (nowPath !== newPath) {
        isShowNav.value = false;
        nowPath = route.path;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("main", _hoisted_2, [_createElementVNode("div", {
        class: "nav-icon-box",
        onClick: navChange
      }, [!isShowNav.value ? (_openBlock(), _createBlock(_component_el_image, {
        key: 0,
        src: require('@/assets/phone/icons/icon_nav.png'),
        class: "img-format"
      }, {
        error: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(IconPicture))]),
          _: 1
        })])]),
        _: 1
      }, 8, ["src"])) : (_openBlock(), _createBlock(_component_el_icon, {
        key: 1,
        class: "icon-close"
      }, {
        default: _withCtx(() => [_createVNode(_unref(CircleClose))]),
        _: 1
      }))]), _createElementVNode("h1", {
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('/')),
        title: "首页"
      }, [_createVNode(_component_el_image, {
        src: require('@/assets/img/public/logo@2x.png'),
        class: "img-format animate__animated animate__bounceIn"
      }, {
        error: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(IconPicture))]),
          _: 1
        })])]),
        _: 1
      }, 8, ["src"])])]), _createVNode(_unref(PhoneMenu), {
        isShowNav: isShowNav.value,
        onEChangeRouter: _cache[1] || (_cache[1] = $event => isShowNav.value = false)
      }, null, 8, ["isShowNav"])]);
    };
  }
});